

import React, { useEffect, useState } from 'react';
export default function PacientesScreen({ token, usuario }) {
  const [pacientes, setPacientes] = useState([]);
  const [tratamientos, setTratamientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [nuevo, setNuevo] = useState({ nombre: '', email: '', password: '', edad: '', genero: '', diagnostico: '', tratamientos: [] });
  const [mensaje, setMensaje] = useState('');
  const [editPaciente, setEditPaciente] = useState(null);

  useEffect(() => {
    if (!usuario.uid) {
      setError('Error: El usuario autenticado no tiene UID. Por favor, cierra sesión y vuelve a ingresar.');
      setLoading(false);
      return;
    }
    setLoading(true);
  fetch(`https://api.braineka.com/usuarios?role=paciente&psicologo_uid=${usuario.uid}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(data => {
          let pacientes = [];
          if (Array.isArray(data)) {
            pacientes = data;
          } else if (data && Array.isArray(data.data)) {
            pacientes = data.data;
          }
          // Transformar tratamientos_ids en array de números
          pacientes = pacientes.map(p => ({
            ...p,
            tratamientos: p.tratamientos_ids ? p.tratamientos_ids.split(',').map(Number) : []
          }));
          setPacientes(pacientes);
          setLoading(false);
        })
        .catch(() => { setError('Error cargando pacientes'); setLoading(false); });
  }, [token, usuario]);

  useEffect(() => {
    if (!usuario.tenant_id) return;
  fetch(`https://api.braineka.com/tratamientos?tenant_id=${usuario.tenant_id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setTratamientos(data))
      .catch(() => {});
  }, [token, usuario]);

  const borrarPaciente = async (id) => {
    if (!window.confirm('¿Seguro que deseas eliminar este paciente?')) return;
    try {
  const res = await fetch(`https://api.braineka.com/usuarios/pacientes/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.ok) {
        setPacientes(p => p.filter(pac => pac.id !== id));
        setMensaje('Paciente eliminado correctamente.');
      } else {
        setError('Error: ' + (data.error || 'No se pudo eliminar el paciente'));
      }
    } catch (err) {
      setError('Error de red o servidor');
    }
  };

  const crearPaciente = async e => {
    e.preventDefault();
    setError('');
    setMensaje('');
    const body = {
      ...nuevo,
      tratamientos: nuevo.tratamientos || [],
      tenant_id: usuario.tenant_id,
      psicologo_uid: usuario.uid,
      role: 'usuario'
    };
    try {
  const res = await fetch('https://api.braineka.com/usuarios', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'No se pudo crear paciente');
      setPacientes(p => [...p, data]);
      setNuevo({ nombre: '', email: '', password: '', edad: '', genero: '', diagnostico: '', tratamientos: [] });
      setMensaje('Paciente registrado y correo enviado correctamente.');
    } catch (e) {
      setError('Error creando paciente o enviando correo.');
    }
  };

  if (loading) return <div>Cargando pacientes...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <h3>Pacientes</h3>
      <div style={{ marginBottom: 18, color: '#444', fontSize: 15, background: '#f4f8ff', borderRadius: 6, padding: '10px 16px', maxWidth: 600 }}>
        Llena la ficha del paciente con sus datos, agrega su correo y asígnale una password. Selecciona el o los tratamientos que le correspondan.
      </div>
      {mensaje && <div style={{ background: '#e6ffe6', color: '#207520', border: '1px solid #b2e6b2', borderRadius: 6, padding: '8px 14px', marginBottom: 12 }}>{mensaje}</div>}
      {error && <div style={{ background: '#ffe6e6', color: '#a00', border: '1px solid #e6b2b2', borderRadius: 6, padding: '8px 14px', marginBottom: 12 }}>{error}</div>}
      <form onSubmit={crearPaciente} style={{ marginBottom: 20 }}>
        <input name="nombre" placeholder="Nombre" value={nuevo.nombre} onChange={e => setNuevo({ ...nuevo, nombre: e.target.value })} required />
        <input name="email" type="email" placeholder="Email" value={nuevo.email} onChange={e => setNuevo({ ...nuevo, email: e.target.value })} required />
        <input name="password" type="password" placeholder="Contraseña" value={nuevo.password} onChange={e => setNuevo({ ...nuevo, password: e.target.value })} required />
        <input name="edad" placeholder="Edad" value={nuevo.edad} onChange={e => setNuevo({ ...nuevo, edad: e.target.value })} />
        <select name="genero" value={nuevo.genero} onChange={e => setNuevo({ ...nuevo, genero: e.target.value })} required>
          <option value="">Selecciona género</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>
        <input name="diagnostico" placeholder="Diagnóstico" value={nuevo.diagnostico} onChange={e => setNuevo({ ...nuevo, diagnostico: e.target.value })} />
        {tratamientos.length > 0 && (
          <div style={{ margin: '10px 0' }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Tratamientos asignados:</label>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              background: '#f8f8f8',
              borderRadius: 8,
              padding: 0,
              border: '1px solid #e0e0e0',
              overflow: 'hidden'
            }}>
              {tratamientos.map((t, idx) => (
                <label
                  key={t.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: idx % 2 === 0 ? '#e3f0ff' : '#fff',
                    borderBottom: idx === tratamientos.length - 1 ? 'none' : '1px solid #e0e0e0',
                    padding: '8px 16px',
                    fontSize: 15,
                    width: '100%'
                  }}
                >
                  <span style={{ flex: '2 1 0', textAlign: 'left', wordBreak: 'break-word' }}>{t.nombre}</span>
                  <div style={{ flex: '1 1 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <input
                      type="checkbox"
                      value={t.id}
                      checked={nuevo.tratamientos.includes(t.id)}
                      onChange={e => {
                        const checked = e.target.checked;
                        const value = Number(e.target.value);
                        setNuevo(n => {
                          let next = n.tratamientos.slice();
                          if (checked) {
                            if (!next.includes(value)) next.push(value);
                          } else {
                            next = next.filter(id => id !== value);
                          }
                          return { ...n, tratamientos: next };
                        });
                      }}
                    />
                  </div>
                </label>
              ))}
            </div>
          </div>
        )}
        <button type="submit">Agregar paciente</button>
      </form>
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Edad</th>
            <th>Género</th>
            <th>Diagnóstico</th>
            <th>Tratamientos</th>
            <th>Notas</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {pacientes.map(p => (
            <tr key={p.id}>
              <td><b>{p.nombre}</b></td>
              <td>{p.email}</td>
              <td>{p.edad}</td>
              <td>{p.genero}</td>
              <td>{p.diagnostico}</td>
              <td>
                {Array.isArray(p.tratamientos) && p.tratamientos.length > 0
                  ? p.tratamientos.map((tid, idx) => {
                      const t = tratamientos.find(tt => tt.id === tid);
                      return t ? (
                        <span key={tid} style={{background:'#e0e0e0',borderRadius:4,padding:'2px 6px',marginRight:4}}>{t.nombre}</span>
                      ) : (
                        <span key={tid + '-' + idx}>{tid}</span>
                      );
                    })
                  : <span style={{color:'#888'}}>Sin tratamientos</span>}
              </td>
              <td>
                <button onClick={() => setEditPaciente(p)}>Editar</button>
                <button style={{ marginLeft: 8, color: '#a00', borderColor: '#a00' }} onClick={() => borrarPaciente(p.id)}>Borrar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        {/* Modal de notas eliminado */}
      {editPaciente && (
        <EditarPacienteModal
          paciente={editPaciente}
          tratamientos={tratamientos}
          token={token}
          onClose={() => setEditPaciente(null)}
          onSave={async (updated) => {
            // Actualizar paciente en backend
            try {
              const res = await fetch(`https://api.braineka.com/usuarios/${editPaciente.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(updated)
              });
              if (!res.ok) throw new Error('No se pudo actualizar paciente');
              // Actualizar en frontend
              setPacientes(pacientes => pacientes.map(p => p.id === editPaciente.id ? { ...p, ...updated } : p));
              setEditPaciente(null);
            } catch (e) {
              alert('Error actualizando paciente');
            }
          }}
        />
      )}
    </div>
  );
}

function EditarPacienteModal({ paciente, tratamientos, token, onClose, onSave }) {
  const [form, setForm] = React.useState({
    nombre: paciente.nombre || '',
    email: paciente.email || '',
    edad: paciente.edad || '',
    genero: paciente.genero || '',
    diagnostico: paciente.diagnostico || '',
    tratamientos: paciente.tratamientos || []
  });
  const [saving, setSaving] = React.useState(false);
  const [tratPage, setTratPage] = React.useState(0);
  const TRAT_PAG_SIZE = 5;
  const totalTratPages = Math.ceil(tratamientos.length / TRAT_PAG_SIZE);
  const tratamientosPage = tratamientos.slice(tratPage * TRAT_PAG_SIZE, (tratPage + 1) * TRAT_PAG_SIZE);

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };
  const handleTratamiento = (id) => {
    setForm(f => {
      const next = f.tratamientos.includes(id)
        ? f.tratamientos.filter(tid => tid !== id)
        : [...f.tratamientos, id];
      return { ...f, tratamientos: next };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave({
      nombre: form.nombre,
      email: form.email,
      edad: form.edad,
      genero: form.genero,
      diagnostico: form.diagnostico,
      tratamientos: form.tratamientos
    });
    setSaving(false);
  };

  return (
    <div style={{ position: 'fixed', top: 40, left: 0, right: 0, margin: 'auto', maxWidth: 500, background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 24, zIndex: 1000 }}>
      <h3>Editar paciente</h3>
      <form onSubmit={handleSubmit}>
        <input name="nombre" placeholder="Nombre" value={form.nombre} onChange={handleChange} required />
        <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
        <input name="edad" placeholder="Edad" value={form.edad} onChange={handleChange} />
        <select name="genero" value={form.genero} onChange={handleChange} required>
          <option value="">Selecciona género</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>
        <input name="diagnostico" placeholder="Diagnóstico" value={form.diagnostico} onChange={handleChange} />
        <div style={{ margin: '10px 0' }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Tratamientos asignados:</label>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            background: '#f8f8f8',
            borderRadius: 8,
            padding: 0,
            border: '1px solid #e0e0e0',
            overflow: 'hidden'
          }}>
            {tratamientosPage.map((t, idx) => (
              <label
                key={t.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: (tratPage * TRAT_PAG_SIZE + idx) % 2 === 0 ? '#e3f0ff' : '#fff',
                  borderBottom: idx === tratamientosPage.length - 1 ? 'none' : '1px solid #e0e0e0',
                  padding: '8px 16px',
                  fontSize: 15,
                  width: '100%'
                }}
              >
                <span style={{ flex: '2 1 0', textAlign: 'left', wordBreak: 'break-word' }}>{t.nombre}</span>
                <div style={{ flex: '1 1 0', display: 'flex', justifyContent: 'flex-end' }}>
                  <input
                    type="checkbox"
                    value={t.id}
                    checked={form.tratamientos.includes(t.id)}
                    onChange={() => handleTratamiento(t.id)}
                  />
                </div>
              </label>
            ))}
          </div>
          {totalTratPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8, gap: 8 }}>
              <button type="button" onClick={() => setTratPage(p => Math.max(0, p - 1))} disabled={tratPage === 0}>&lt;</button>
              <span style={{ fontSize: 14 }}>Página {tratPage + 1} de {totalTratPages}</span>
              <button type="button" onClick={() => setTratPage(p => Math.min(totalTratPages - 1, p + 1))} disabled={tratPage === totalTratPages - 1}>&gt;</button>
            </div>
          )}
        </div>
        <button type="submit" disabled={saving}>Guardar</button>
        <button type="button" onClick={onClose} style={{ marginLeft: 8 }}>Cancelar</button>
      </form>
    </div>
  );
}



